import React from "react";
import PropTypes from "prop-types";

const AccountingOperations = ({
  search,
  setSearch,
  typeFilter,
  setTypeFilter,
  handleOnClickButtons,
  Button,
  ButtonGreen
}) => (
  <div>
    <div className="flex items-center gap-3 mb-2">
      <span className="text-lg font-semibold text-blue-700 tracking-wide">Operaciones</span>
    </div>
    <div className="flex flex-wrap gap-4 items-center justify-center">
      <input
        type="text"
        placeholder="Buscar operación..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        className="px-4 py-2 border border-blue-200 rounded shadow-sm min-w-[200px] focus:ring-2 focus:ring-blue-300 focus:border-blue-400 transition"
      />
      <select value={typeFilter} onChange={e => setTypeFilter(e.target.value)} className="px-4 py-2 border border-blue-200 rounded shadow-sm min-w-[160px] focus:ring-2 focus:ring-blue-300 focus:border-blue-400 transition">
        <option value="all">Todos los tipos</option>
        <option value="income">Ingreso</option>
        <option value="outcome">Egreso</option>
      </select>
      <Button onClick={() => { handleOnClickButtons(false); }} className="font-bold">Nueva Operación</Button>
      <ButtonGreen onClick={() => { handleOnClickButtons(true); }} className="font-bold">Auto Calcular Ingresos</ButtonGreen>
    </div>
  </div>
);

AccountingOperations.propTypes = {
  search: PropTypes.string.isRequired,
  setSearch: PropTypes.func.isRequired,
  typeFilter: PropTypes.string.isRequired,
  setTypeFilter: PropTypes.func.isRequired,
  handleOnClickButtons: PropTypes.func.isRequired,
  Button: PropTypes.elementType.isRequired,
  ButtonGreen: PropTypes.elementType.isRequired
};

export default AccountingOperations;
